// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"8de6edbe","598":"1740dfcb","703":"79f20345","787":"cda612ba"}[chunkId] + ".chunk.js";
};